// extracted by mini-css-extract-plugin
export default {"bar":"StatsBar_bar__omH4I","stat":"StatsBar_stat__VD2BX","num":"StatsBar_num__K-k+V","label":"StatsBar_label__n+22-"};